import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
  selectColumnFactory,
} from "@/react/components/table";
import {
  LOCAL_DATE_TIME_FORMAT,
  TIMESTAMP,
  timestampFormatter,
} from "@/react/datetime";
import { getColumnDef } from "@/react/schema/schemaFields";

import schema from "./schema";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.email, "Email"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.status, "Status"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.reason, "Reason"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.ip, "IP"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.created, "Created At"),
        type: TYPES.UNIX_TIMESTAMP,
        timestampFormatter: timestampFormatter(
          TIMESTAMP.UNITS.SECONDS,
          TIMESTAMP.ZONE.LOCAL,
          LOCAL_DATE_TIME_FORMAT
        ),
        timestampUnit: TIMESTAMP.UNITS.SECONDS,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
